import React, { FC } from 'react';
import { Route as RouteDefault } from 'react-router-dom';
import { RouteProps } from 'react-router';
import { setBasenameToPathname } from 'srcJs/helpers/LanguageHelper';

const Route: FC<RouteProps> = ({
  path,
  ...props
}) => {
  const buildPath = (
    pathForBuild: string,
  ): string => `/:locale?${setBasenameToPathname(pathForBuild)}`;

  let pathNew;
  if (Array.isArray(path)) {
    pathNew = path.map((pathElement) => buildPath(pathElement));
  } else {
    pathNew = buildPath(path);
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <RouteDefault path={pathNew} {...props} />;
};

export { Route };
